type ClassificationLite = { source: string; has_sport_field: boolean | null };

/**
 * Final has_sport_field across classification sources.
 * True if satellite OR web_research says true.
 * Otherwise: satellite's value, then any other source's value, else null.
 */
export function resolveHasSportField(
  classifications: ClassificationLite[] | null | undefined,
): boolean | null {
  if (!classifications?.length) return null;
  if (
    classifications.some(
      (c) =>
        (c.source === "satellite" || c.source === "web_research") &&
        c.has_sport_field === true,
    )
  ) {
    return true;
  }
  const satellite = classifications.find((c) => c.source === "satellite");
  return satellite?.has_sport_field ?? classifications[0]?.has_sport_field ?? null;
}
